/*
 * Smores Blog List — presentational category filter.
 * Clicking a tab toggles which cards (by data-tags) are visible.
 * "All" shows every card. Purely client-side / cosmetic; the featured
 * post is always shown. Server pagination still works via the link.
 */
(function () {
  function init(root) {
    var tabs = root.querySelectorAll('.smores-blog-list__tab');
    if (!tabs.length) return;
    var cards = root.querySelectorAll('.smores-blog-list__grid .smores-blog-list__card');

    function apply(tag) {
      cards.forEach(function (card) {
        var tags = (card.getAttribute('data-tags') || '').split(/\s+/);
        var show = tag === 'all' || tags.indexOf(tag) !== -1;
        card.hidden = !show;
      });
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) {
          t.classList.remove('is-active');
          t.setAttribute('aria-selected', 'false');
        });
        tab.classList.add('is-active');
        tab.setAttribute('aria-selected', 'true');
        apply(tab.getAttribute('data-tag'));
      });
    });
  }

  function boot() {
    document.querySelectorAll('.smores-blog-list').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
